import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { FlangeTypeModel } from '../../../models';
import { Router } from '@angular/router';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Subject } from 'rxjs';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-flange-type',
    templateUrl: './flange-type.component.html',
    styleUrls: ['./flange-type.component.scss'],
})
export class FlangeTypeComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set standardId(value: string) {
        this._standardId = value;
        if (!this.jointCalcService.isPipeCode) this.getFlangeTypes();
    }
    get standardId(): string {
        return this._standardId;
    }

    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;

        if (!this.jointCalcService.isPipeCode) this.getFlangeTypes();
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set pipeSizeId(value: string) {
        this._pipeSizeId = value;
        if (this.idmsSharedService.enableConfirmWithRouter(1) == true) {
            this.getFlangeTypes();
        }
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }

    @Input()
    set isCustom(value: boolean) {
        this._isCustom = value;
        if (!this.jointCalcService.isPipeCode) this.getFlangeTypes();
    }
    get isCustom(): boolean {
        return this._isCustom;
    }
    destroy$ = new Subject();

    loading: boolean = false;
    tooltip_position = 'above';
    flangeTypeList: FlangeTypeModel[];
    private _standardId: string;
    private _pressureClassId: string;
    private _pipeSizeId: string;
    private _isCustom: boolean;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        public router: Router,
        public idmsSharedService: IdmsSharedService,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithFlangeType();
        }

        this.form.get('flangeType').valueChanges.subscribe((value) => {
            if (value) {
                this.setFlangeDiagramId(value);
                if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode)
                    this.jointCalcService.selectedflangeType.next(value);
            }
        });
    }

    setFlangeDiagramId(flangeTypeId: string): void {
        if (flangeTypeId !== null) {
            this.form.get('flangeDiagramId').setValue(this.flangeTypeList.find((x) => x.flangeTypeId === flangeTypeId)?.diagramId);
            this.dataService.selectedFlangeType = this.flangeTypeList.find((x) => x.flangeTypeId === flangeTypeId)?.flangeTypeName;
        }
    }

    getFlangeTypes(): void {
        this.form.markAllAsTouched();
        if (this.isCustom || (this.standardId != null && this.pressureClassId != null)) {
            this.loading = true;

            this.iceapi
                .getFlangeTypes(this.standardId, this.pressureClassId, this.pipeSizeId, this.isCustom)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .pipe(takeUntil(this.destroy$))
                .subscribe((flangeTypes) => {
                    if (flangeTypes.success === true) {
                        this.flangeTypeList = flangeTypes.response;
                        this.dataService.flangeTypeObj = flangeTypes.response;
                        if (this.flangeTypeList.length === 1) this.form.get('flangeType').setValue(this.flangeTypeList[0].flangeTypeId);
                        this.cd.markForCheck();
                        if (this.form.get('flangeType').value !== '') this.setFlangeDiagramId(this.form.get('flangeType').value);
                    } else {
                        this.user_utility.errorModelPopup(flangeTypes.message);
                    }
                });
        }
    }

    async pipespecwithFlangeType() {
        this.jointCalcService.selectedpipeSize.pipe(takeUntil(this.destroy$)).subscribe(async (pipe) => {
            let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

            InputGroup.recordId.flangeFacingTypeId =
                InputGroup.recordId.flangeMaterialId =
                InputGroup.recordId.gasketId =
                InputGroup.others.boltType =
                InputGroup.recordId.boltMaterialId =
                InputGroup.others.tighteningSpecification =
                    null;

            if (pipe && this.jointCalcService.pipeSpecpayload.lookupParams?.calculationType == CalculationType.StandardFlange) {
                this.loading = true;
                // InputGroup.recordId.pi
                let pipeSpecFlangeType = await this.iceapi
                    .getFlangeTypes(InputGroup.recordId.standardId, InputGroup.recordId.pressureClassId, pipe, this.isCustom)
                    .pipe(finalize(() => (this.loading = false)))
                    .toPromise();

                if (pipeSpecFlangeType.success) {
                    this.flangeTypeList = [...pipeSpecFlangeType.response];

                    this.flangeTypeList = await this.jointCalcService.managePayloadForRecourdId('flangeTypeId', this.flangeTypeList);

                    if (this.flangeTypeList.length === 1) this.form.get('flangeType').setValue(this.flangeTypeList[0].flangeTypeId);
                } else if (pipeSpecFlangeType.isCustom) {
                    this.user_utility.errorModelPopup(pipeSpecFlangeType.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
